/**
 * LoadContent Component in sales/CLP page on clicking more items will be loaded
 *
 * @module views/components/LoadContent
 * @memberof -Common
 */
import './LoadContent.scss';

import React from 'react';

import PropTypes from 'prop-types';

import Button from '@ulta/core/components/Button/Button';
import Text from '@ulta/core/components/Text/Text';
import { isServer } from '@ulta/core/utils/device_detection/device_detection';

/**
  * Represents a LoadContent component
  *
  * @method
  * @param {LoadContentProps} props - React properties passed from composition
  * @returns LoadContent
  */
export const LoadContent = function( props ){
  if( !props.label ){
    return null;
  }

  if( isServer() && props.loadContentUrl ){
    return <a href={ props.loadContentUrl }>{ props.label }</a>;
  }

  return (
    <>
      { props.loadContentUrl && (
        <a href={ props.loadContentUrl }
          className='LoadContent__hiddenAnchor'
        >{ props.label }</a>
      ) }
      <div className='LoadContent'
        data-test='load-content'
      >
        { props.loadContentTitle &&
        <Text
          textStyle={ 'body-2' }
          textAlign={ 'center' }
        >
          { props.loadContentTitle }
        </Text>
        }
        <Button className='LoadContent__button'
          data-test='load-content-button'
          label={ props.label }
          tertiary={ false }
          compact={ true }
          onClick={ props.onLoadContentClick }
          withHover={ true }
          secondary={ true }
          alignment={ 'center' }
          action={ props.loadContentAction }
        />

      </div>
    </>

  );
};

/**
  * Property type definitions
  *
  * @typedef LoadContentProps
  * @type {object}
  * @property {string} loadContentTitle - sets title for LoadContent Items
  * @property {string} label - Sets Label for LoadContent button
  * @property {string} loadContentUrl - Sets href for pagination on the server side
  * @property {function} onLoadContentClick - fires product listing query with pagination
  * @property {object} loadContentAction - fires product datacapture
  */
export const propTypes = {
  loadContentTitle: PropTypes.string,
  label: PropTypes.string.isRequired,
  loadContentUrl: PropTypes.string,
  onLoadContentClick: PropTypes.func,
  loadContentAction: PropTypes.object
};

LoadContent.propTypes = propTypes;


export default LoadContent;
